/*! Wi-maps - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var wiMap;

+function($) {
    'use strict';
    var wiMaps = window.wiMaps;
    window.wiMaps = {
        init: function() {
            if ($('.gmap-map').length) {
                $('.gmap-map').each(function() {
                    var id = $(this).attr('data-id');
                    var lat = $(this).attr('data-lat');
                    var lng = $(this).attr('data-lng');
                    var zoom = $(this).attr('data-zoom');
                    var marker = $(this).attr('data-marker');
                    wiMaps.initialize(id, lat, lng, zoom, marker);
                });
            }
            $(document).on('shown.bs.tab', '.tab-gmaps', function() {
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    if ($('.gmap-map-collapse').length) {
                        $('.gmap-map-collapse').each(function() {
                            var id = $(this).attr('data-id');
                            var lat = $(this).attr('data-lat');
                            var lng = $(this).attr('data-lng');
                            var zoom = $(this).attr('data-zoom');
                            var marker = $(this).attr('data-marker');
                            wiMaps.initialize(id, lat, lng, zoom, marker);
                        });
                    }
                }
            })
        },
        initialize: function(id, lat, lng, map_zoom, map_marker) {
            wiMap = L.map('map_' + id).setView([lat, lng], parseInt(map_zoom));
            L.Icon.Default.imagePath = '{imgPath}/leaflet/';
            var tiles = L.tileLayer('https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
            }).addTo(wiMap);
            tiles.on('tileerror', function(e) {
                if (!e.tile._retried) {
                    e.tile._retried = true;
                    setTimeout(function() { e.tile.src = e.tile.src + '?r'; }, 1500);
                }
            });
            wiMaps.load(id, lat, lng, map_zoom, map_marker);

        },
        load: function(id, main_lat, main_lng, map_zoom, map_marker) {
            var marker;
            var icon;
            if ($(".map_items_" + id).length) {
                if (map_marker) {
                    icon = map_marker;
                }
                $(".map_items_" + id).each(function() {
                    var lat = $(this).attr('data-lat');
                    var lng = $(this).attr('data-lng');
                    var main = $(this).attr('data-main');
                    var item_marker = $(this).attr('data-marker');
                    if (item_marker) {
                        icon = item_marker;
                    }
                    var info = $(this).attr('data-info');
                    /* if (icon) {
                     console.log(icon);
                     var markerIcon = new LeafIcon({iconUrl: icon});
                     marker = new L.marker([lat, lng], {icon: markerIcon}).addTo(wiMap).bindPopup(info);
                     } else {
                     console.log(info);
                     marker = new L.marker([lat, lng]).addTo(wiMap).bindPopup(info);
                     }*/
                    marker = new L.marker([lat, lng]).addTo(wiMap).bindPopup(info);
                    if (main > 0) {
                        marker.openPopup();
                    }
                });
            }
            if ($(".hidden_map_items_" + id).length) {
                $(".hidden_map_items_" + id).each(function() {
                    var lat = $(this).attr('data-lat');
                    var lng = $(this).attr('data-lng');

                    marker = new L.marker([lat, lng]).addTo(wiMap);
                });
            }
        }
    };
    $(document).ready(function() {
        wiMaps = window.wiMaps;
        wiMaps.init();
    });
}(jQuery);